import React from 'react';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Elements from 'ctsutheme/components/atoms';
import Molecules from 'ctsutheme/components/molecules';
import { FasSearch } from 'assets/icons';
import Downshift from 'downshift';
import Paper from '@material-ui/core/Paper';
import { TE } from 'appconstants';

const { Icon } = Elements;
const { InputAdornment } = Molecules;

export function RenderSuggestion(props) {
  const {
    suggestion,
    index,
    itemProps,
    highlightedIndex,
    selectedItem
  } = props;
  const isHighlighted = highlightedIndex === index;
  const isSelected = selectedItem === suggestion;
  return (
    <MenuItem
      key={_.uniqueId('prtAuto')}
      {...itemProps}
      selected={isHighlighted}
      component="div"
      style={{ fontWeight: isSelected ? 600 : 400 }}
    >
      {suggestion}
    </MenuItem>
  );
}

export function RenderInput(inputProps) {
  const {
    InputProps, classes, ref, onSearchClick, name, ...other
  } = inputProps;
  return (
    <TextField
      id="outlined-name"
      fullWidth
      name={name}
      placeholder="Find Protocol"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Icon onClick={onSearchClick}><FasSearch /></Icon>
          </InputAdornment>
        ),
        disableUnderline: true,
        inputRef: ref,
        className: 'flex-wrap-nowrap',
        classes: {
          root: classes?.inputRoot,
          input: classes?.inputInput,
          focused: classes?.focused
        },
        inputProps: {
          title: {name},
          'data-id': `${TE.ID}${name}${TE.TEXT}`
        },
        ...InputProps
      }}
      {...other}
    />
  );
}

export const AutoDownshift = ({
  classes,
  downshiftOnChange,
  name,
  handleSearchClick,
  getSuggestions,
  handleEnterKeyPress,
  suggestions,
  placeholderText,
  selectedValue,
  suggestionSize
}) => (
  <Downshift
    onChange={downshiftOnChange}
    id="downshift-simple"
    selectedItem={selectedValue || ''}
  >
    {({
      getInputProps,
      getItemProps,
      getMenuProps,
      highlightedIndex,
      isOpen,
      selectedItem
    }) => (
      <div className={classes?.container}>
        {RenderInput({
          fullWidth: true,
          classes,
          name,
          onSearchClick: handleSearchClick,
          InputProps: getInputProps({
            placeholder: placeholderText,
            onChange: getSuggestions,
            onKeyUp: handleEnterKeyPress
          })
        })}
        <div {...getMenuProps()}>
          {isOpen ? (
            <Paper className={classes?.paper} square  style={{ maxHeight: suggestionSize || "90vh", overflowY: 'auto' }}>
              {suggestions
                ? suggestions.map((suggestion, index) => RenderSuggestion({
                  suggestion,
                  index,
                  itemProps: getItemProps({ item: suggestion }),
                  highlightedIndex,
                  selectedItem
                }))
                : null}
            </Paper>
          ) : null}
        </div>
      </div>
    )}
  </Downshift>
);

export const AutoStyles = theme => ({
  root: {
    flexGrow: 1,
    textAlign: 'right'
  },
  container: {
    position: 'relative'
  },
  paper: {
    position: 'absolute',
    zIndex: 2,
    marginTop: theme.spacing(1),
    left: 10,
    right: 0
  },
  chip: {
    margin: `${theme.spacing(1)}px ${theme.spacing(1)}px`
  },
  inputRoot: {
    flexWrap: 'wrap'
  },
  focused: {
    border: '0 !important'
  },
  inputInput: {
    flexGrow: 1,
    outlineOffset: 0,
    width: 50,
    height: 10
  },
  divider: {
    height: theme.spacing(1.5)
  }
});
